import Cookies from 'js-cookie';

// #1 Submit form
(function ($) {
  var $accessResourcesEl = $('.bbc-wb-access');
  var $accessResourceRedirect = $('.js-bbc-wb-access-redirect-btn');
  var $accessResourceLoader = $('.js-blog-section-loader');
  var redirectUrl =
    $accessResourceRedirect.length > 0
      ? $accessResourceRedirect.attr('href')
      : null;

  var cookieName = 'gfDlSubmittedBBCWB';

  // Open Project Download Modal after form is successfully submitted
  if ($accessResourcesEl.length > 0 && redirectUrl) {
    $(document).on('gform_confirmation_loaded', function (event, formId) {
      if (
        $accessResourcesEl.data('form-id') > 0 &&
        formId == $accessResourcesEl.data('form-id')
      ) {
        // set cookie which expires in 1 week
        Cookies.set(cookieName, true, { expires: 7 });

        // redirect to Resources center
        location.assign(redirectUrl);
      }
    });
  }

  // If form was already submitted, hide form and show open button
  if (Cookies.get(cookieName)) {
    $('.js-bbc-wb-access-form').remove();
    $('.js-bbc-wb-access-redirect-btn').addClass('is-active');
  }

  // Prevent access to Resources center by loading posts via AJAX
  if ($('.page-template-template-resource-center').length > 0) {
    var data = {
      action: 'load-resource-center-items',
      postId: GLOBAL.post_id,
      cookie: Cookies.get(cookieName),
      loggedIn: GLOBAL.is_logged_in,
    };

    $.ajax({
      type: 'GET',
      url: GLOBAL.ajax,
      data: data,
      beforeSend: function () {
        $accessResourceLoader.addClass('is-active');
      },
      success: function (data) {
        if (data.success === true) {
          $('.js-resouces-center-container').append($(data.data));
        }
      },
      complete: function () {
        $accessResourceLoader.removeClass('is-active');
      },
    });
  }
})(jQuery);
